import {
  SHOW_QTY_SELECTOR,
  HIDE_QTY_SELECTOR,
  SET_DISPLAY_ID,
} from "./actionTypes";

export const actions = {
  showBottomSheet: (payload) => ({ type: SHOW_QTY_SELECTOR, payload }),
  hideBottomSheet: () => ({ type: HIDE_QTY_SELECTOR }),
  setDisplayId: (payload) => ({ type: SET_DISPLAY_ID, payload }),
};

const initialState = {
  visible: false,
  items: [],
  identifier: "",
  displayId: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_QTY_SELECTOR:
      return {
        ...state,
        visible: true,
        items: action.payload.items,
        identifier: action.payload.identifier,
      };
    case HIDE_QTY_SELECTOR:
      return initialState;
    case SET_DISPLAY_ID:
      return {
        ...state,
        displayId: action.payload,
      };
    default:
      return state;
  }
};
reducer.initialState = initialState;
export default reducer;
